import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import type { EmbeddedNavigationProps } from '../types/Rewards';

const useEmbeddedNavigation = () => {
  const embedded = useSelector(select.device.isEmbedded);
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  const { modal } = useDispatch<Dispatch>();

  return useCallback(
    ({ modal: modalState, c2l, c2lMobile = c2l }: EmbeddedNavigationProps) => {
      embedded
        ? window.starsweb?.app.execute(isMobileEmbedded ? c2lMobile : c2l)
        : modal.replace([modalState]);
    },
    [embedded, isMobileEmbedded, modal]
  );
};

export default useEmbeddedNavigation;
